const menu_toggle = document.getElementById('menu-toggle');
const sidebar = document.getElementById('sidebar');
const hamburger = document.getElementById('hamburger');

menu_toggle.addEventListener('click', e => {
    const menuIsOpen = e.currentTarget.getAttribute('aria-expanded') === 'true';

    if(!menuIsOpen) {
        sidebar.classList.add('aside--active');
        hamburger.classList.add('hamburger--active');
        menu_toggle.setAttribute('aria-expanded', 'true');
    } else {
        sidebar.classList.remove('aside--active');
        hamburger.classList.remove('hamburger--active');
        menu_toggle.setAttribute('aria-expanded', 'false');
    }
});
